import { UserService } from './UserService';

export const Service = {
  User: UserService,
};
